export default __webpack_public_path__ + "media/titles/title_5_locale_es-987334db.png";